// extracted by mini-css-extract-plugin
export default {"DefaultPricesContainer":"DefaultPriceList_DefaultPricesContainer__2x2Cc","Price":"DefaultPriceList_Price__-x7em","Divider":"DefaultPriceList_Divider__ylZ76"};